import { PostOperation } from '@/api/rest/base/operations';
import BaseApi from './base/BaseApi';

/**
 * Записи истории спецификации (ТЗ 4.1, 6.2): «Импортировать снова» файл из записи о файле импорта;
 * ответ — новое задание импорта (202). Список истории читается через SpecificationApi.
 * Сгенерировано Claude.
 */
export default class SpecHistoryApi extends BaseApi {
  static entityName = 'spec_histories';

  reimport(id, withPreloader = false) {
    const operation = new PostOperation(`${this.getIri(id)}/reimport`, {});
    return this.execute(operation, withPreloader);
  }
}
